import React, { useEffect, useRef } from 'react'
// AntV G2Plot
import { Line } from '@antv/g2plot'
// i18
import { useTranslation } from 'react-i18next'

export const Linea = ({graph}) => {
    const { t } = useTranslation(["translation"])
    const chartRef = useRef(null)

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        const data = []

        if (graph===null) {
            data.push(
                {
                    name: `${t("example")} 1`,
                    value: 100,
                },
                {
                    name: `${t("example")} 2`,
                    value: 120,
                },
                {
                    name: `${t("example")} 3`,
                    value: 80,
                },
                {
                    name: `${t("example")} 4`,
                    value: 90,
                },
                {
                    name: `${t("example")} 5`,
                    value: 110,
                },
            )
        }
        else if(graph.channel) {
            const campos = graph.fields[graph.channel]
            campos.forEach((field) => {
                field.value.forEach((element) => {
                    const obj = {
                        name: formatDate(element.dateTime),
                        value: element.value
                    };
                    data.push(obj);
                });
            });
        }
        else {
            const campos = graph.fields
            campos.forEach((field) => {
                field.value.forEach((element) => {
                    const obj = {
                        name: formatDate(element.dateTime),
                        value: element.value
                    };
                    data.push(obj);
                });
            });
        }

        if (chartRef.current) {
            const linePlot = new Line(chartRef.current, {
                data,
                xField: 'name',
                yField: 'value',
                point: {
                    size: 5,
                    shape: 'diamond',
                },
                xAxis: {
                    title: {
                        text: t("time"),
                        fontSize: 18,
                    },
                },
            })

            linePlot.render()
        }
    }, [])

    return <div ref={chartRef} style={{ width: "80%", height: "80%" }} />
}
